import { render, staticRenderFns } from "./UcSuggestContractServiceOption.yaml?vue&type=template&id=43309d9c&component"
import script from "./UcSuggestContractServiceOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestContractServiceOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports